// import { mount } from '@cypress/react';

import { Box, Container } from '@material-ui/core';
import React from 'react';
import Logo from '../../../assets/logo_sgsante.svg';
import btnLogout from '../../../assets/btnLogout.svg';
import btnLogin from '../../../assets/btnLogin.svg';
import { useAppContext } from 'core/contexts';
import { useHistory } from 'react-router';

type Props = {
    className?: string;
    displayBtnLogout?: Boolean;
};

const SmallHeader: React.FC<Props> = ({ className, displayBtnLogout = true }) => {
    const { logout, user, isLogged } = useAppContext();
    const history = useHistory();

    const logoutAndReload = () => {
        logout();
        window.location.href = '/connexion';
    };

    return (
        <>
            <Box style={{ background: 'white' }} className={className}>
                <Container>
                    <Box display={'flex'} flexDirection={'row'}>
                        <Box flex={'initial'} style={{ padding: '20px', cursor: 'pointer' }} onClick={() => (isLogged() ? logoutAndReload() : history.push('/'))}>
                            <img src={Logo} height={'70'} width={'auto'} alt="" />
                        </Box>
                        {displayBtnLogout && (
                            <Box flexGrow={1} style={{ textAlign: 'right', padding: '20px' }}>
                                <Box style={{ paddingTop: '10px' }}>
                                    {user.token ? (
                                        <span onClick={() => logoutAndReload()} style={{ cursor: 'pointer' }}>
                                            <img src={btnLogout} height={'50'} width={'auto'} alt="" />
                                        </span>
                                    ) : (
                                        <span onClick={() => logoutAndReload()} style={{ cursor: 'pointer' }}>
                                            <img src={btnLogin} height={'50'} width={'auto'} alt="" />
                                        </span>
                                    )}
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default SmallHeader;
